import React, { useState } from 'react';
import chevronUp from '~/icons/chevron-up.svg';
import JobListing from '~/components/JobListing';

function JobCategory({ className, showAnswer = false, heading, jobList, numberOf }) {
  const [isSelected, setIsSelected] = useState(showAnswer);


  return (
    <div className="mb-12 select-none">
      <header onClick={() => setIsSelected(!isSelected)} className="flex justify-between mb-1 cursor-pointer group">
        <div>
          <h4 className="text-h4">{heading}</h4>
          <div className="text-17px">
            <p>{jobList.length} {numberOf}</p>
          </div>
        </div>
        <button className="w-12 h-12 rounded-full ">
          <div
            className={`w-12 h-12 transform transition-all duration-150 border-2 border-black rounded-full group-hover:border-blue group-hover:bg-blue flex justify-center items-center ${
              isSelected && 'bg-blue border-blue rotate-180'
            }`}
          >
            <img
              src={chevronUp}
              className={`transform rotate-180 group-hover:filter group-hover:invert ${isSelected && 'filter invert'}`}
              alt=""
            />
          </div>
        </button>
      </header>
      {isSelected && (
        <div className="mt-12">
          {jobList.map((list, i) => (
            <div key={`jobList${heading+i}`} className="mb-3">
              <JobListing  {...list} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default JobCategory;
